import { Provider } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import "./App.css";
import { Toast } from "./Controllers/Toast";
import "./Media.css";
import Layout from "./Pages/Layout";
import Locations from "./Pages/Locations";
import Login from "./Pages/Login";
import { persistor, store } from "./Redux/store";
import { useEffect } from "react";
import { getInstalledExtensions } from "./Redux/Action/extensions.action";

function App() {

  return (
    <>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="/locations" element={<Locations />} />
              {/* <Route path="*" element={<NotFound />} /> */}
            </Routes>
            <Layout />
            <Toast />
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </>
  );
}

export default App;
